import { Recipe } from "./RecipeSchema";

export function sortRecipesByPriority(recipes: Recipe[]): Recipe[] {
  return [...recipes].sort((a, b) => a.priority - b.priority);
}
